<template>
  <div class="container">
    <div class="tab-show">
      <div
        class="tab-tr"
        :class="showIndex==index?'show-tr':''"
        v-for="(item,index) in tabbar"
        @click="showTab(item)"
        :key="index"
      >{{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "switchHallTabbar",
    props: ["region"],
    data() {
      return {
        tabbar: [],
        showIndex: 0,
      };
    },
    created() {
      this.tabbar = [
        {
          index: 0,
          name: "待提交",
        },
        {
          index: 1,
          name: "已提交",
        },
      ]
    },
    methods: {
      showTab(item) {
        this.showIndex = item.index;
        this.$parent.changeType(this.showIndex + 1);
      },
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
  }

  .tab-show {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tab-tr {
    margin: 0 30px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 33px;
    color: #777777;
    opacity: 1;
    padding: 0 0 19px 0;
    border-bottom: solid 2px #ffffff;
    cursor: pointer;
  }

  .show-tr {
    color: #231815;
    border-bottom: solid 2px #777777;
  }

  .bottom {
    width: 58px;
    height: 0px;
    border: 2px solid #707070;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/switchTabbar/switchHallTabbar.vue